// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .hide-scroll-bar::-webkit-scrollbar {
    display: none;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/hidescrollbarx.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf","sourcesContent":[".hide-scroll-bar {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  .hide-scroll-bar::-webkit-scrollbar {\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
